import { languages } from "./content.js";

const dictionary = {
  en: {
    "meta.description": "Atlas of Lost Art — a calm journey through world art told in visual puzzles.",
    "brand.tagline": "Atlas of Lost Art",
    "lang.switch": "Русский",
    "lang.code": "EN",
    "account.open": "Open profile",
    "account.signin": "Sign in",
    "sound.off": "Turn sound off",
    "sound.on": "Turn sound on",
    "intro.eyebrow": "Expedition No. 01",
    "intro.title": "Art <em>remembers the way.</em>",
    "intro.lead": "Restore vanished masterpieces, discover their stories and build a museum that exists only for you.",
    "intro.begin": "Begin the journey",
    "intro.continue": "Continue the journey",
    "intro.museum": "Return to the museum",
    "intro.session": "≈ 12 min",
    "intro.sessionNote": "first expedition",
    "intro.dailyKicker": "Daily restoration",
    "intro.dailyTitle": "A new object is waiting",
    "intro.dailyPlayers": "players",
    "intro.works": "artworks",
    "intro.mechanics": "puzzle types",
    "intro.expeditions": "expeditions",
    "intro.privacy": "Privacy",
    "analytics.settings": "Data settings",
    "analytics.kicker": "Your choice",
    "analytics.title": "Help improve the museum?",
    "analytics.copy": "Allow anonymous first-party usage analytics. No advertising SDKs, cross-site tracking or account linkage.",
    "analytics.details": "Read the privacy policy",
    "analytics.accept": "Allow analytics",
    "analytics.decline": "Not now",
    "intro.how": "How it works",
    "intro.howToast": "60 artworks · 6 puzzle types · a daily world ranking",
    "game.home": "Back to the start screen",
    "game.routeProgress": "Expedition progress",
    "game.found": "Artworks found",
    "game.daily": "Daily restoration",
    "journey.route": "Route {number}",
    "journey.status": "en route",
    "journey.lead": "Twenty routes, sixty artworks and the stories of makers from around the world.",
    "journey.collection": "My collection",
    "puzzle.chapter": "Chapter {number} · {city}",
    "puzzle.ranked": "Ranked · {city}",
    "puzzle.difficulty": "Difficulty",
    "puzzle.restored": "Restored",
    "puzzle.undo": "Undo",
    "puzzle.reset": "Restart",
    "puzzle.hint": "Hint",
    "puzzle.resetToast": "The puzzle has been scrambled again",
    "artifact.kicker": "Expedition object",
    "artifact.alt": "Fragment of the artwork being sought",
    "artifact.hidden": "Title hidden",
    "artifact.curator": "Curator's note",
    "reveal.stamp": "Restored",
    "reveal.kicker": "New discovery",
    "reveal.time": "{time}",
    "reveal.hints": "{count} hints",
    "reveal.hintsOne": "1 hint",
    "reveal.noHints": "no hints",
    "reveal.moves": "{count} moves",
    "reveal.collection": "Collection",
    "reveal.source": "Art Institute of Chicago · public domain",
    "reveal.hang": "Hang in the museum",
    "reveal.openMuseum": "Open your museum",
    "reveal.submit": "Submit result",
    "reveal.checking": "Verifying the solution…",
    "reveal.retry": "Retry verification",
    "reveal.share": "Share",
    "reveal.shareText": "I restored “{name}” by {artist} in {time} with {hints} in Atlas of Lost Art.",
    "reveal.shareCopied": "The text has been copied. Paste it wherever you like.",
    "collection.close": "Close",
    "collection.kicker": "Your personal museum",
    "collection.title": "Your museum",
    "collection.of": "of",
    "collection.works": "artworks",
    "collection.restart": "Start the expedition again",
    "collection.locked": "Not yet found",
    "collection.unknown": "Unknown object",
    "collection.unknownAlt": "Undiscovered artwork",
    "collection.restartToast": "A new expedition has begun",
    "arena.eyebrow": "Updates every day",
    "arena.title": "Daily<br><em>restoration</em>",
    "arena.lead": "One object for every player. Three attempts, server-side verification and a place in the world ranking.",
    "arena.countdown": "Until the next object",
    "arena.challenge": "Today's challenge",
    "arena.today": "Today · world ranking",
    "arena.location": "{city} · world ranking",
    "arena.loading": "Loading the object…",
    "arena.unknownPuzzle": "The puzzle is revealed before you start.",
    "arena.mechanic": "{mechanic} · difficulty {difficulty}/3",
    "arena.attempts": "attempts",
    "arena.penalty": "hint penalty",
    "arena.oneBoard": "one board",
    "arena.start": "Start an attempt",
    "arena.startRemaining": "Start an attempt · {remaining} left",
    "arena.exhausted": "No attempts left",
    "arena.signinToPlay": "Sign in and take part",
    "arena.needProfile": "Play without an account; a name is asked after the first result.",
    "arena.updating": "The challenge is updating…",
    "arena.offline": "The online service is unavailable right now. The campaign works offline.",
    "arena.verifiedByServer": "Every move is verified by the server.",
    "arena.best": "Best result: {score} points",
    "arena.result": "{score} points · rank #{rank}",
    "arena.leaderboardKicker": "Live ranking",
    "arena.leaderboardTitle": "Today's best",
    "arena.refresh": "Refresh the ranking",
    "arena.leaderboardLoading": "Loading the ranking…",
    "arena.leaderboardEmpty": "Be the first restorer of the day",
    "arena.leaderboardOffline": "The ranking is temporarily unavailable",
    "arena.startedToast": "Ranked attempt started · {remaining} left",
    "arena.resultToast": "Result confirmed: {score} points · rank #{rank}",
    "arena.levelMissing": "The object of the day is not in the catalogue",
    "arena.signinFirst": "Create a profile or sign in first",
    "account.kicker": "Explorer profile",
    "account.title": "Keep your path across devices",
    "account.copy": "The campaign works without an account. A profile is needed for a cloud museum and a fair ranking.",
    "account.titleSigned": "Your path is saved",
    "account.copySigned": "Progress syncs with the server and verified results take part in the ranking.",
    "account.handle": "Ranking name",
    "account.handlePlaceholder": "art_explorer",
    "account.password": "Password",
    "account.passwordPlaceholder": "At least 10 characters",
    "account.login": "Sign in",
    "account.register": "Create a profile",
    "account.role": "Explorer",
    "account.stats": "{count} discoveries · {result}",
    "account.noResult": "no result today",
    "account.todayScore": "{score} points today",
    "account.logout": "Sign out",
    "account.delete": "Delete account",
    "account.registered": "Profile created, museum saved",
    "account.welcome": "Welcome back to the expedition",
    "account.loggedOut": "You have signed out. Your local museum is kept.",
    "account.deleteConfirm": "Delete the profile, cloud progress and all ranking results permanently?",
    "account.deletePrompt": "Enter your password to confirm deletion:",
    "account.deleted": "The account and server data have been deleted",
    "hint.ring": "The ring that is still out of place is highlighted",
    "hint.layer": "Move the highlighted band to the {direction}",
    "hint.left": "left",
    "hint.right": "right",
    "hint.pair": "These two pieces belong together",
    "hint.rotate": "The highlighted piece is still turned the wrong way",
    "hint.mosaic": "Try the highlighted piece",
    "mechanic.mosaic": "Sliding mosaic",
    "mechanic.rings": "Rings of the tide",
    "mechanic.layers": "Image layers",
    "mechanic.swap": "Swap the pieces",
    "mechanic.rotate": "Turn the pieces",
    "mechanic.sequence": "Ribbons of time",
    "aria.blank": "Empty cell",
    "aria.tile": "Piece {number}",
    "aria.selectTile": "Select piece {number}",
    "aria.tileSelected": "Piece {number}, selected",
    "aria.rotateTile": "Turn piece {number}, currently {degrees} degrees",
    "aria.strip": "Select strip {number}",
    "aria.stripSelected": "Strip {number}, selected",
    "aria.ringOuter": "Outer ring, turn 90 degrees",
    "aria.ringMiddle": "Middle ring, turn 90 degrees",
    "aria.ringInner": "Inner ring, turn 90 degrees",
    "aria.layer": "Band {number}, offset {offset}",
    "aria.layerLeft": "Move band {number} left",
    "aria.layerRight": "Move band {number} right",
    "aria.done": "completed",
    "aria.current": "current chapter",
    "aria.locked": "locked",
    "aria.chapter": "{city}: {status}",
    "sw.offline": "The game is ready to work offline",
    "sw.update": "The new version will install on the next launch",
    "atlas.kicker": "Expedition {number} · {done} of {total}",
    "atlas.next": "Next stop · {city}",
    "atlas.nextFirst": "First stop · {city}",
    "atlas.replay": "Replay · {city}",
    "atlas.continue": "Continue the expedition",
    "atlas.begin": "Begin the expedition",
    "atlas.complete": "Every hall is open",
    "atlas.lockedToast": "This stop opens after the previous one",
    "atlas.doneToast": "Restored again",
    "atlas.expeditions": "Expeditions",
    "atlas.stops": "{done} / {total}",
    "atlas.museum": "Museum",
    "atlas.ranking": "Ranking",
    "atlas.streak": "{count}-day streak",
    "atlas.noStreak": "No streak yet",
    "atlas.today": "Today · {title} · {players} playing",
    "atlas.todayTime": "Daily restoration · 2 min",
    "atlas.dailyDone": "Done today · rank #{rank}",
    "streak.title": "{count}-day streak",
    "streak.none": "Start your streak today",
    "streak.best": "best {count}",
    "streak.rule": "One missed day a week does not break the streak.",
    "guest.playAs": "You play as {label}. Pick a name for the ranking:",
    "guest.namePlaceholder": "restorer_42",
    "guest.save": "Save name",
    "guest.saved": "Your name is in the ranking",
    "guest.hint": "Create a profile later to keep results across devices.",
    "arena.startGuest": "Start · no sign-up needed",
    "arena.guestStatus": "Playing as {label}. Every move is verified by the server.",
    "arena.resultPlayers": "{score} points · rank #{rank} of {players}",
    "share.card": "Share card",
    "share.cardReady": "The card is ready to share",
    "share.cardSaved": "The card has been saved",
    "share.day": "Day {day}",
    "share.campaign": "Chapter {number}",
    "share.kicker": "Daily restoration",
    "share.kickerCampaign": "Restoration",
    "share.rank": "Rank #{rank} of {players}",
    "share.legendFast": "found early",
    "share.legendMid": "midway",
    "share.legendSlow": "last to settle",
    "share.streak": "{count}-day streak",
    "share.noStreak": "First restoration",
    "share.museum": "Museum: {count} of {total} artworks",
    "share.tease": "Which artwork? Find out yourself.",
    "share.file": "atlas-of-lost-art.png",
    "hall.impressionists": "Light of Europe",
    "hall.masters": "Old Masters",
    "hall.asia": "The East",
    "hall.ancient": "Ancient World",
    "hall.africa": "Africa",
    "hall.americas": "The Americas",
    "museum.hall": "Hall · {name}",
    "museum.found": "{count} of {total}",
    "museum.empty": "Not yet found",
    "museum.walk": "Walk the halls",
    "museum.share": "Show my museum",
    "museum.shareText": "My museum in Atlas of Lost Art: {count} of {total} artworks restored.",
    "museum.shareCopied": "Museum summary copied",
    "pass.kicker": "Expedition {number} is locked",
    "pass.title": "The <em>Full Museum</em>",
    "pass.lead": "Try the first two expeditions and the daily restoration for free. One purchase opens the whole museum forever.",
    "pass.benefit1": "All {count} artworks across {expeditions} expeditions",
    "pass.benefit2": "One purchase. No subscription and no advertising",
    "pass.benefit3": "All future improvements and additions in version 1.x",
    "pass.benefit4": "Restore access and carry your museum across devices",
    "pass.storeSoon": "A one-time App Store, Google Play and web purchase is being connected. There will be no recurring charge. Until then, an access code opens the museum.",
    "pass.codeLabel": "Access code",
    "pass.codePlaceholder": "e.g. PRESS-2026",
    "pass.redeem": "Unlock with a code",
    "pass.restore": "Restore access",
    "pass.active": "Temporary access is active until {date}",
    "pass.activeForever": "The full museum is open forever",
    "pass.redeemed": "The whole collection is open",
    "pass.invalid": "This code is not valid",
    "pass.restored": "Access checked",
    "pass.locked": "Open the full museum",
    "pass.lockedToast": "This expedition is part of the full museum",
    "pass.gift": "Gift the full museum",
    "error.generic": "The service is temporarily unavailable"
  },
  ru: {
    "meta.description": "Atlas of Lost Art — спокойное путешествие по мировому искусству через визуальные головоломки.",
    "brand.tagline": "Атлас утраченного искусства",
    "lang.switch": "English",
    "lang.code": "RU",
    "account.open": "Открыть профиль",
    "account.signin": "Войти",
    "sound.off": "Выключить звук",
    "sound.on": "Включить звук",
    "intro.eyebrow": "Экспедиция № 01",
    "intro.title": "Искусство <em>помнит путь.</em>",
    "intro.lead": "Восстанавливайте исчезнувшие шедевры, открывайте их истории и собирайте музей, который существует только у вас.",
    "intro.begin": "Начать путешествие",
    "intro.continue": "Продолжить путешествие",
    "intro.museum": "Вернуться в музей",
    "intro.session": "≈ 12 мин",
    "intro.sessionNote": "первая экспедиция",
    "intro.dailyKicker": "Ежедневная реставрация",
    "intro.dailyTitle": "Новый объект уже ждёт",
    "intro.dailyPlayers": "участников",
    "intro.works": "произведений",
    "intro.mechanics": "механик",
    "intro.expeditions": "экспедиций",
    "intro.privacy": "Конфиденциальность",
    "analytics.settings": "Настройки данных",
    "analytics.kicker": "Ваш выбор",
    "analytics.title": "Помочь улучшить музей?",
    "analytics.copy": "Разрешить анонимную аналитику на нашем сервере. Без рекламных SDK, межсайтового отслеживания и связи с профилем.",
    "analytics.details": "Прочитать политику конфиденциальности",
    "analytics.accept": "Разрешить аналитику",
    "analytics.decline": "Не сейчас",
    "intro.how": "Как это работает",
    "intro.howToast": "60 произведений · 6 механик · ежедневный мировой рейтинг",
    "game.home": "Вернуться на главный экран",
    "game.routeProgress": "Прогресс экспедиции",
    "game.found": "Найдено произведений",
    "game.daily": "Ежедневная реставрация",
    "journey.route": "Маршрут {number}",
    "journey.status": "в пути",
    "journey.lead": "Двадцать маршрутов, шестьдесят произведений и истории мастеров со всего мира.",
    "journey.collection": "Моя коллекция",
    "puzzle.chapter": "Глава {number} · {city}",
    "puzzle.ranked": "Рейтинг · {city}",
    "puzzle.difficulty": "Сложность",
    "puzzle.restored": "Восстановлено",
    "puzzle.undo": "Отменить",
    "puzzle.reset": "Заново",
    "puzzle.hint": "Подсказка",
    "puzzle.resetToast": "Головоломка собрана заново",
    "artifact.kicker": "Объект экспедиции",
    "artifact.alt": "Фрагмент искомого произведения",
    "artifact.hidden": "Название скрыто",
    "artifact.curator": "Заметка куратора",
    "reveal.stamp": "Восстановлено",
    "reveal.kicker": "Новое открытие",
    "reveal.time": "{time}",
    "reveal.hints": "{count} подсказок",
    "reveal.hintsOne": "1 подсказка",
    "reveal.noHints": "без подсказок",
    "reveal.moves": "{count} ходов",
    "reveal.collection": "Коллекция",
    "reveal.source": "Art Institute of Chicago · общественное достояние",
    "reveal.hang": "Повесить в музей",
    "reveal.openMuseum": "Открыть свой музей",
    "reveal.submit": "Зафиксировать результат",
    "reveal.checking": "Проверяем решение…",
    "reveal.retry": "Повторить проверку",
    "reveal.share": "Поделиться",
    "reveal.shareText": "Я восстановил(а) «{name}» ({artist}) за {time} {hints} в Atlas of Lost Art.",
    "reveal.shareCopied": "Текст скопирован. Вставьте его, куда захотите.",
    "collection.close": "Закрыть",
    "collection.kicker": "Ваш личный музей",
    "collection.title": "Ваш музей",
    "collection.of": "из",
    "collection.works": "произведений",
    "collection.restart": "Начать экспедицию заново",
    "collection.locked": "Не открыто",
    "collection.unknown": "Неизвестный объект",
    "collection.unknownAlt": "Неоткрытое произведение",
    "collection.restartToast": "Новая экспедиция началась",
    "arena.eyebrow": "Обновляется каждый день",
    "arena.title": "Ежедневная<br><em>реставрация</em>",
    "arena.lead": "Один объект для всех игроков. Три попытки, серверная проверка результата и место в мировом рейтинге.",
    "arena.countdown": "До нового объекта",
    "arena.challenge": "Испытание дня",
    "arena.today": "Сегодня · мировой зачёт",
    "arena.location": "{city} · мировой зачёт",
    "arena.loading": "Загрузка объекта…",
    "arena.unknownPuzzle": "Головоломка станет известна перед стартом.",
    "arena.mechanic": "{mechanic} · сложность {difficulty}/3",
    "arena.attempts": "попытки",
    "arena.penalty": "штраф за подсказки",
    "arena.oneBoard": "один зачёт",
    "arena.start": "Начать попытку",
    "arena.startRemaining": "Начать попытку · осталось {remaining}",
    "arena.exhausted": "Попытки исчерпаны",
    "arena.signinToPlay": "Войти и участвовать",
    "arena.needProfile": "Играйте без аккаунта; имя спросим после первого результата.",
    "arena.updating": "Испытание обновляется…",
    "arena.offline": "Онлайн-сервис сейчас недоступен. Кампания работает офлайн.",
    "arena.verifiedByServer": "Результат проверяется сервером по каждому ходу.",
    "arena.best": "Лучший результат: {score} очков",
    "arena.result": "{score} очков · место №{rank}",
    "arena.leaderboardKicker": "Живой рейтинг",
    "arena.leaderboardTitle": "Лучшие сегодня",
    "arena.refresh": "Обновить рейтинг",
    "arena.leaderboardLoading": "Рейтинг загружается…",
    "arena.leaderboardEmpty": "Станьте первым реставратором дня",
    "arena.leaderboardOffline": "Рейтинг временно недоступен",
    "arena.startedToast": "Рейтинговая попытка началась · осталось {remaining}",
    "arena.resultToast": "Результат подтверждён: {score} очков · место №{rank}",
    "arena.levelMissing": "Объект дня не найден в каталоге",
    "arena.signinFirst": "Сначала создайте профиль или войдите",
    "account.kicker": "Профиль исследователя",
    "account.title": "Сохраните путь между устройствами",
    "account.copy": "Кампания работает без аккаунта. Профиль нужен для облачного музея и честного рейтинга.",
    "account.titleSigned": "Ваш путь сохранён",
    "account.copySigned": "Прогресс синхронизируется с сервером, а подтверждённые результаты участвуют в рейтинге.",
    "account.handle": "Имя в рейтинге",
    "account.handlePlaceholder": "art_explorer",
    "account.password": "Пароль",
    "account.passwordPlaceholder": "Не менее 10 символов",
    "account.login": "Войти",
    "account.register": "Создать профиль",
    "account.role": "Исследователь",
    "account.stats": "{count} открытий · {result}",
    "account.noResult": "без результата сегодня",
    "account.todayScore": "{score} очков сегодня",
    "account.logout": "Выйти",
    "account.delete": "Удалить аккаунт",
    "account.registered": "Профиль создан, музей сохранён",
    "account.welcome": "С возвращением в экспедицию",
    "account.loggedOut": "Вы вышли из профиля. Локальный музей сохранён.",
    "account.deleteConfirm": "Удалить профиль, облачный прогресс и все рейтинговые результаты без возможности восстановления?",
    "account.deletePrompt": "Введите пароль для подтверждения удаления:",
    "account.deleted": "Аккаунт и серверные данные удалены",
    "hint.ring": "Подсвечено кольцо, которое ещё не совпало",
    "hint.layer": "Сдвиньте подсвеченный слой {direction}",
    "hint.left": "влево",
    "hint.right": "вправо",
    "hint.pair": "Эти два фрагмента стоит сопоставить",
    "hint.rotate": "Подсвеченный фрагмент ещё повёрнут неверно",
    "hint.mosaic": "Попробуйте подсвеченный фрагмент",
    "mechanic.mosaic": "Сдвижная мозаика",
    "mechanic.rings": "Круги прилива",
    "mechanic.layers": "Слои изображения",
    "mechanic.swap": "Обмен фрагментов",
    "mechanic.rotate": "Поворот фрагментов",
    "mechanic.sequence": "Ленты времени",
    "aria.blank": "Пустая ячейка",
    "aria.tile": "Фрагмент {number}",
    "aria.selectTile": "Выбрать фрагмент {number}",
    "aria.tileSelected": "Фрагмент {number}, выбран",
    "aria.rotateTile": "Повернуть фрагмент {number}, сейчас {degrees} градусов",
    "aria.strip": "Выбрать полосу {number}",
    "aria.stripSelected": "Полоса {number}, выбрана",
    "aria.ringOuter": "Внешнее кольцо, повернуть на 90 градусов",
    "aria.ringMiddle": "Среднее кольцо, повернуть на 90 градусов",
    "aria.ringInner": "Внутреннее кольцо, повернуть на 90 градусов",
    "aria.layer": "Слой {number}, смещение {offset}",
    "aria.layerLeft": "Сдвинуть слой {number} влево",
    "aria.layerRight": "Сдвинуть слой {number} вправо",
    "aria.done": "пройдено",
    "aria.current": "текущая глава",
    "aria.locked": "закрыто",
    "aria.chapter": "{city}: {status}",
    "sw.offline": "Игра готова к работе без интернета",
    "sw.update": "Новая версия установится при следующем запуске",
    "atlas.kicker": "Экспедиция {number} · {done} из {total}",
    "atlas.next": "Следующая остановка · {city}",
    "atlas.nextFirst": "Первая остановка · {city}",
    "atlas.replay": "Повторить · {city}",
    "atlas.continue": "Продолжить экспедицию",
    "atlas.begin": "Начать экспедицию",
    "atlas.complete": "Все залы открыты",
    "atlas.lockedToast": "Эта остановка откроется после предыдущей",
    "atlas.doneToast": "Восстановлено заново",
    "atlas.expeditions": "Экспедиции",
    "atlas.stops": "{done} / {total}",
    "atlas.museum": "Музей",
    "atlas.ranking": "Рейтинг",
    "atlas.streak": "Серия {count} дн.",
    "atlas.noStreak": "Серии пока нет",
    "atlas.today": "Сегодня · {title} · играют {players}",
    "atlas.todayTime": "Реставрация дня · 2 мин",
    "atlas.dailyDone": "Сегодня решено · место №{rank}",
    "streak.title": "Серия {count} дн.",
    "streak.none": "Начните серию сегодня",
    "streak.best": "рекорд {count}",
    "streak.rule": "Один пропуск в неделю не сжигает серию.",
    "guest.playAs": "Вы играете как {label}. Выберите имя для рейтинга:",
    "guest.namePlaceholder": "restorer_42",
    "guest.save": "Сохранить имя",
    "guest.saved": "Имя записано в рейтинг",
    "guest.hint": "Профиль можно создать позже, чтобы сохранять результаты на всех устройствах.",
    "arena.startGuest": "Начать · без регистрации",
    "arena.guestStatus": "Вы играете как {label}. Каждый ход проверяется сервером.",
    "arena.resultPlayers": "{score} очков · место №{rank} из {players}",
    "share.card": "Открытка",
    "share.cardReady": "Открытка готова",
    "share.cardSaved": "Открытка сохранена",
    "share.day": "День {day}",
    "share.campaign": "Глава {number}",
    "share.kicker": "Реставрация дня",
    "share.kickerCampaign": "Реставрация",
    "share.rank": "Место №{rank} из {players}",
    "share.legendFast": "нашлись сразу",
    "share.legendMid": "в середине",
    "share.legendSlow": "встали последними",
    "share.streak": "Серия {count} дн.",
    "share.noStreak": "Первая реставрация",
    "share.museum": "Музей: {count} из {total} произведений",
    "share.tease": "Какое произведение? Узнайте сами.",
    "share.file": "atlas-of-lost-art.png",
    "hall.impressionists": "Свет Европы",
    "hall.masters": "Старые мастера",
    "hall.asia": "Восток",
    "hall.ancient": "Древний мир",
    "hall.africa": "Африка",
    "hall.americas": "Америка",
    "museum.hall": "Зал · {name}",
    "museum.found": "{count} из {total}",
    "museum.empty": "Ещё не найдено",
    "museum.walk": "Пройти по залам",
    "museum.share": "Показать музей",
    "museum.shareText": "Мой музей в Atlas of Lost Art: восстановлено {count} из {total} произведений.",
    "museum.shareCopied": "Описание музея скопировано",
    "pass.kicker": "Экспедиция {number} закрыта",
    "pass.title": "<em>Полный музей</em>",
    "pass.lead": "Попробуйте первые две экспедиции и реставрацию дня бесплатно. Одна покупка открывает весь музей навсегда.",
    "pass.benefit1": "Все {count} произведений в {expeditions} экспедициях",
    "pass.benefit2": "Одна покупка. Без подписки и без рекламы",
    "pass.benefit3": "Все будущие улучшения и дополнения версии 1.x",
    "pass.benefit4": "Восстановление доступа и музей на всех устройствах",
    "pass.storeSoon": "Подключается разовая покупка в App Store, Google Play и на сайте. Регулярных списаний не будет. Пока музей открывает код доступа.",
    "pass.codeLabel": "Код доступа",
    "pass.codePlaceholder": "например, PRESS-2026",
    "pass.redeem": "Открыть по коду",
    "pass.restore": "Восстановить доступ",
    "pass.active": "Временный доступ действует до {date}",
    "pass.activeForever": "Полный музей открыт навсегда",
    "pass.redeemed": "Вся коллекция открыта",
    "pass.invalid": "Такой код не подходит",
    "pass.restored": "Доступ проверен",
    "pass.locked": "Открыть полный музей",
    "pass.lockedToast": "Эта экспедиция входит в полный музей",
    "pass.gift": "Подарить полный музей",
    "error.generic": "Сервис временно недоступен"
  }
};

const STORAGE_KEY = "atlas-lang";

export function detectLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (languages.includes(stored)) return stored;
  } catch (_) {}
  const preferred = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  return preferred.some(tag => tag.toLowerCase().startsWith("ru")) ? "ru" : "en";
}

let current = typeof navigator === "undefined" ? "en" : detectLanguage();

export const getLanguage = () => current;

export function setLanguage(lang) {
  if (!languages.includes(lang)) return current;
  current = lang;
  try { localStorage.setItem(STORAGE_KEY, lang); } catch (_) {}
  return current;
}

export function t(key, params = {}, lang = current) {
  const template = dictionary[lang]?.[key] ?? dictionary.en[key] ?? key;
  return template.replace(/\{(\w+)\}/g, (_, name) => (params[name] ?? `{${name}}`));
}

export const locale = () => (current === "ru" ? "ru-RU" : "en-US");

export function applyStaticTranslations(root = document) {
  root.querySelectorAll("[data-i18n]").forEach(node => { node.textContent = t(node.dataset.i18n); });
  root.querySelectorAll("[data-i18n-html]").forEach(node => { node.innerHTML = t(node.dataset.i18nHtml); });
  root.querySelectorAll("[data-i18n-label]").forEach(node => { node.setAttribute("aria-label", t(node.dataset.i18nLabel)); });
  root.querySelectorAll("[data-i18n-placeholder]").forEach(node => { node.setAttribute("placeholder", t(node.dataset.i18nPlaceholder)); });
  root.querySelectorAll("[data-i18n-alt]").forEach(node => { node.setAttribute("alt", t(node.dataset.i18nAlt)); });
  document.documentElement.lang = current;
  document.querySelector('meta[name="description"]')?.setAttribute("content", t("meta.description"));
}

export const missingKeys = lang => Object.keys(dictionary.en).filter(key => !(key in dictionary[lang]));
export const dictionaryKeys = () => Object.keys(dictionary.en);
